//  React Base Styles
import borders from 'assets/theme/base/borders';
import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

//  React helper functions
import pxToRem from 'assets/theme/functions/pxToRem';

const { inputBorderColor, info, grey, transparent, black } = colors;
const { borderRadius, borderWidth } = borders;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.blue,
      fontSize: size.md,
      fontWeight: '600',
      borderRadius: borderRadius.md,

      // height: '3.5rem',

      '&:hover .MuiOutlinedInput-notchedOutline': {
        // borderColor: inputBorderColor,
      },

      // '&[aria-expanded="true"]': {
      //   borderBottom: 'none',
      // },

      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          // borderColor: inputBorderColor,
        },
      },
    },

    notchedOutline: {
      borderColor: inputBorderColor,
      // borderBottom: 'none',
    },

    input: {
      color: black.main,
      padding: pxToRem(12),
      backgroundColor: transparent.main,
    },

    inputSizeSmall: {
      fontSize: size.xs,
      padding: pxToRem(10),
    },

    multiline: {
      color: grey[700],
      padding: 0,
    },
  },
};

export default inputOutlined;
